import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { TooltipModule } from "@cloudfactorydk/ng2-tooltip-directive";
import { IonicModule } from '@ionic/angular';
import { DesktopHeaderComponentModule } from 'src/app/shared/desktop-header/desktop-header.module';
import { ProductLabelModule } from 'src/app/shared/shop/product-card/product-label/product-label.module';
import { QtyStepperModule } from 'src/app/shared/shop/qty-stepper/qty-stepper.module';
import { VariantChipsModule } from 'src/app/shared/shop/variant-chips/variant-chips.module';
import { ProductCustomElementsComponent } from "../product-custom-elements/product-custom-elements.component";
import { ProductVariantsModule } from '../product-variants/product-variants.module';
import { ProductsInPackComponent } from '../products-in-pack/products-in-pack.component';
import { ProductPartInfoInteractionComponent } from './product-part-info-interaction.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule,
    DesktopHeaderComponentModule,
    QtyStepperModule,
    ProductVariantsModule,
    ProductLabelModule,
    VariantChipsModule,
    ReactiveFormsModule,
    TooltipModule
  ],
  declarations: [ProductPartInfoInteractionComponent, ProductCustomElementsComponent, ProductsInPackComponent],
  exports: [ProductPartInfoInteractionComponent, ProductCustomElementsComponent]
})
export class ProductPartInfoInteractionComponentModule {
}
